var React = require('react');

function Project (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 3 6 L 3 14 L 8.6347656 14 L 12 19.908203 L 12 27 L 20 27 L 20 19 L 13.783203 19 L 10.9375 14 L 11 14 L 11 11 L 21 11 L 21 14 L 29 14 L 29 6 L 21 6 L 21 9 L 11 9 L 11 6 L 3 6 z M 5 8 L 9 8 L 9 12 L 5 12 L 5 8 z M 23 8 L 27 8 L 27 12 L 23 12 L 23 8 z M 14.417969 21 L 18 21 L 18 25 L 14 25 L 14 21.238281 L 14.417969 21 z"}));
}

Project.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Project;

Project.default = Project;
